import { ChangeDetectorRef, Component, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'medworld-expo';
  isOnline: boolean = navigator.onLine;
  showSidebar: boolean = true;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) {
    // Set default language
    translate.setDefaultLang('en');

    // Detect environment and load corresponding GA key
    const env = this.getEnvironment();

    const gaKeyMap: { [key: string]: string } = {
      dev: 'G-5TR4ZJ1WQG',
      qa: 'G-0CX902QEPG',
      prod: 'G-VVK6X83CDE'
    };

    const gaKey = gaKeyMap[env];
    this.loadGoogleAnalytics(gaKey);

    // Track route changes
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        gtag('config', gaKey, {
          page_path: event.urlAfterRedirects
        });
      }
    });
  }

  // Detect current environment from URL
  getEnvironment(): 'dev' | 'qa' | 'prod' | 'local' {
    const hostname = window.location.hostname;

    if (hostname.includes('dev.medworld')) {
      return 'dev';
    } else if (hostname.includes('qa.medworld')) {
      return 'qa';
    } else if (hostname.includes('medworld')) {
      return 'prod';
    } else {
      return 'local';
    }
  }

  // Dynamically load GA script
  private loadGoogleAnalytics(gaKey: string) {
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaKey}`;
    script.async = true;
    document.head.appendChild(script);

    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){ dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', '${gaKey}', { send_page_view: false });
    `;
    document.head.appendChild(inlineScript);
  }

  // Switch app language
  switchLanguage(language: string) {
    this.translate.use(language);
  }

  // Handle offline event
  @HostListener('window:offline')
  onOffline() {
    this.isOnline = false;
    this.cdr.detectChanges();
  }

  // Handle online event
  @HostListener('window:online')
  onOnline() {
    this.isOnline = true;
    window.location.reload();
  }
}
